import React from "react";
import {
     MainLeftTitle,
} from "../../../_uiComponents/WrapperComponents";
import { UiFullLoadingSpinner } from "../../../_uiComponents/common/UiLoadingSpinner";
import { VoucherManagement } from "./VoucherManagement";

function VoucherManagementWrapper() {

     return (
          <>
           <UiFullLoadingSpinner loader={true}/>
          <div className="sbt-data-grid__wr">
               <MainLeftTitle title="Voucher Management">
               </MainLeftTitle>
               <br/>
               <VoucherManagement />
          </div>
          </>
     );
}

export default VoucherManagementWrapper;